import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import "./../../pagescss/QuizStarting.css";
import AllQuestions from "../AllData/AllQuestions";
import { formatTime, getCurrentOptions } from "./quiz/utils/quizUtils";
import { QuizResults } from "./quiz/components/QuizResults";
import { QuizStartScreen } from "./quiz/components/QuizStartScreen";
import { QuestionNavigation } from "./quiz/components/QuestionNavigation";
import { useQuizHandlers } from "./quiz/hooks/reUseQuizHandlers";
import { FaBars, FaTimes } from "react-icons/fa";
import Loading from "../home/Loading";
import Latex from 'react-latex';

function QuizReStarting() {
  const [submissions, setSubmissions] = useState([]);
  const { quizsubjectName, quizId, id } = useParams();
  const allQuizSubmisstions = submissions;
  const questions = AllQuestions;
  const [allanswer, setAllanswer] = useState([]);
  const [questionsId, setQuestionsId] = useState([]);
  const phone = "12345";
  const loading = false;

  useEffect(() => {
    const saved = localStorage.getItem('quizSubmissions');
    const data = saved ? JSON.parse(saved) : [];
    setSubmissions(data);
  }, []);

  // Effect 1: Aggregate all individual 'answer' objects
  useEffect(() => {
    if (quizId && allQuizSubmisstions?.length > 0) {
      const filtered = allQuizSubmisstions.filter(data => data?.quizId === quizId);

      const allAnswerObjects = filtered.flatMap(submission => {
        // Safely access answers, defaulting to an empty array
        return submission.answers || [];
      });

      setAllanswer(allAnswerObjects);
    } else {
      setAllanswer([]);
    }
  }, [allQuizSubmisstions, quizId]);

  // Effect 2: Extract question IDs from the aggregated answers
  useEffect(() => {
    if (allanswer?.length > 0) {
      // Map over the array of answer objects to extract the ID, 
      // then filter out any invalid/missing IDs.
      const allQuestionIds = allanswer
        .map(answer => answer?.questionId)
        .filter(questionId => questionId != null);

      setQuestionsId(allQuestionIds);
    } else {
      setQuestionsId([]);
    }
  }, [allanswer]);

  const filterQuestions = questionsId.length > 0 
    ? questions.filter(questions => questionsId.includes(questions._id.$oid))
    : [];

  const totalQuizTimeInSeconds = filterQuestions.length * 60;
  const [quizStart, setQuizStart] = useState(false);
  const [timeLeft, setTimeLeft] = useState(totalQuizTimeInSeconds);
  const [showSidebar, setShowSidebar] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const subjectName = quizsubjectName
  const quizName = subjectName;

  const {
    selectedAnswers,
    markedQuestions,
    hasSelectedOption,
    currentQuestionIndex,
    isSubmitted,
    score,
    handleOptionChange,
    handleNextQuestion,
    handlePreviousQuestion,
    handleQuestionButtonClick,
    toggleMarkQuestion,
    handleSubmit,
    handleStartQuiz,
  } = useQuizHandlers(
    filterQuestions,
    phone,
    quizId,
    id,
    quizName,
    totalQuizTimeInSeconds,
    timeLeft
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setShowSidebar(true);
      } else {
        setShowSidebar(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const startQuiz = () => {
    handleStartQuiz();
    setQuizStart(true);
    setTimeLeft(totalQuizTimeInSeconds);

    window.history.pushState(null, '', window.location.href);
  };

  useEffect(() => {
    if (timeLeft > 0 && !isSubmitted && quizStart) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else if (timeLeft === 0 && !isSubmitted && quizStart) {
      handleSubmit(true);
    }
  }, [timeLeft, isSubmitted, quizStart, handleSubmit]);

  const currentQuestion = filterQuestions[currentQuestionIndex];
  const answeredCount = hasSelectedOption.filter((selected) => selected).length;
  const unansweredCount = filterQuestions.length - answeredCount;
  const markedCount = markedQuestions.filter((mark) => mark).length;

  // Function to render text with LaTeX
  const renderWithLatex = (text) => {
    if (!text) return null;

    // Check if text contains LaTeX patterns
    if (text.includes('$') || text.includes('\\')) {
      return <Latex>{text}</Latex>;
    }
    return text;
  };

  //Not leaving 
  useEffect(() => {
    if (!quizStart) return;
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = 'Are you sure you want to leave? Your quiz progress will be lost.';
      return e.returnValue;
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    const handlePopState = (e) => {
      if (quizStart) {
        e.preventDefault();
        window.history.pushState(null, '', window.location.href);
      }
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [quizStart]);

  // Add loading state for empty filterQuestions
  if (loading) {
    return <Loading message="Loading......" />
  }

  // Check if questions are loaded
  if (filterQuestions.length === 0 && quizStart) {
    return <Loading message="Loading questions..." />;
  }

  return (
    <>
      {quizStart ? (
        <div className="quiz-container">
          {/* Mobile Menu Button */}
          {isMobile && (
            <button
              className="mobile-menu-button"
              onClick={() => setShowSidebar(!showSidebar)}
            >
              {showSidebar ? <FaTimes /> : <FaBars />}
            </button>
          )}

          {/* Sidebar */}
          <div className={`quiz-sidebar ${showSidebar ? 'show' : ''}`}>
            <div className="sidebar-content-quiz">
              <div className="sidebar-header-quiz">
                <h2>{quizName.charAt(0).toUpperCase() + quizName.slice(1).toLowerCase()} mock test</h2>
              </div>

              <div className="question-stats">
                <div className="stat-item">
                  <span className="stat-label">Total:</span>
                  <span className="stat-value">{filterQuestions.length}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label answered">Answered:</span>
                  <span className="stat-value">{answeredCount}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label unanswered">Unanswered:</span>
                  <span className="stat-value">{unansweredCount}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label marked">Marked:</span>
                  <span className="stat-value">{markedCount}</span>
                </div>
              </div>

              <div className="question-navigation">
                <QuestionNavigation
                  questions={filterQuestions}
                  hasSelectedOption={hasSelectedOption}
                  currentQuestionIndex={currentQuestionIndex}
                  markedQuestions={markedQuestions}
                  handleQuestionButtonClick={(index) => {
                    handleQuestionButtonClick(index);
                    if (isMobile) setShowSidebar(false);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="quiz-main-content">
            <div className="main-content-inner">
              <div className="quiz-header">
                {!isMobile && (<h1>{quizName} mock test</h1>)}
                {isMobile && (
                  <div className="timer-mobile">
                    <span>Time Left: </span>
                    <span className="time-value">{formatTime(timeLeft)}</span>
                  </div>
                )}

                {!isMobile && (
                  <div className="timer">
                    <span>Time Left: </span>
                    <span className="time-value">{formatTime(timeLeft)}</span>
                  </div>
                )}

              </div>



          



              {!isSubmitted ? (
                <>
                  <div className="question-container">
                    <div className="question-section">
                      <p className="question-number">{currentQuestionIndex + 1} of {filterQuestions.length}</p>
                      {currentQuestion && currentQuestion.question_img ? (
                        <img src={`/questionsPhoto/${currentQuestion.question_img}`} alt="Description of image" className="question-image" />
                      ) : currentQuestion ? (
                        <p className="question-text">{renderWithLatex(currentQuestion.question)} {currentQuestion.year}</p>
                      ) : (
                        <p className="question-text">Loading question...</p>
                      )}
                    </div>




                    


                       

                    <div className="options-section">
                      {currentQuestion && getCurrentOptions(currentQuestion).map((option, index) => (
                        <div key={index} className="option-item">
                          <label className="option-label">
                            <input
                              type="radio"
                              name="option"
                              value={`option${index + 1}`}
                              checked={selectedAnswers[currentQuestionIndex] === `option${index + 1}`}
                              onChange={handleOptionChange}
                              className="option-input"
                            />
                            <span className="option-text">{renderWithLatex(option.label)}</span>
                          </label>
                        </div>
                      ))}
                      {!currentQuestion && (
                        <div className="loading-options">
                          <p>Loading options...</p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="navigation-buttons">
                    <button
                      onClick={handlePreviousQuestion}
                      disabled={currentQuestionIndex === 0}
                      className="nav-button prev-button"
                    >
                      Previous
                    </button>
                    <button
                      onClick={toggleMarkQuestion}
                      className={`nav-button mark-button ${markedQuestions[currentQuestionIndex] ? 'marked' : ''}`}
                    >
                      {markedQuestions[currentQuestionIndex] ? "Unmark" : "Mark"}
                    </button>
                    {currentQuestionIndex < filterQuestions.length - 1 ? (
                      <button
                        onClick={handleNextQuestion}
                        className="nav-button next-button"
                      >
                        Next
                      </button>
                    ) : (
                      <button
                        onClick={() => handleSubmit(false)}
                        className="nav-button submit-button"
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </>
              ) : (
                <QuizResults
                  score={score}
                  questions={filterQuestions}
                  quizId={quizId}
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <QuizStartScreen
          questions={questionsId}
          totalQuizTimeInSeconds={totalQuizTimeInSeconds}
          subjectName={quizName}
          handleStartQuiz={startQuiz}
        />
      )}
    </>
  );
}

export default QuizReStarting;